
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class CPSnackBar extends Vue {

  @Prop({ required: false })
  public message!: string;

  @Prop({ default: 'default' })
  public type!: string;

  @Prop({ required: false })
  public hasIcon!: false;

  @Prop({ required: false, default: false })
  public hasClose!: boolean;

  public close() {
    this.$store.commit('updateSnackbar', {
      message: null,
      type: 'default',
      hasClose: false,
      hasIcon: false,
      autoClose: false,
    });
  }

}
